// extracted by mini-css-extract-plugin
export default {"page_container":"LandingPage_page_container__tQbpF"};